module.exports = __webpack_public_path__ + "img/3c.245b0098.png";